import React from "react";
import {
  Button,
  Dialog,
  DialogContent,
  DialogActions,
  Box,
  CardMedia,
  Typography,
  Stack,
} from "@mui/material";
import { useAuth0 } from "@auth0/auth0-react";
import { useAccountContext } from "../../context/AccountContext";
import checklistDone from "src/public/assets/illustrations/checklistDone1.png";
import handleCompleteSetup from "./setupComplete";

function SetupComplete({ setupCompleteDialogOpen }) {
  const { user, getAccessTokenSilently } = useAuth0();
  const { fetchAccountData, handleCloseSuccessDialog } = useAccountContext();
  const apiUrl = process.env.REACT_APP_API_URL;
  const [isLoading, setIsLoading] = React.useState(false);

  const handleButtonClick = async () => {
    setIsLoading(true); // Start loading state
    await handleCompleteSetup(
      user,
      getAccessTokenSilently,
      apiUrl,
      handleCloseSuccessDialog,
    );
    setIsLoading(false); // Stop loading state
  };

  return (
    <Dialog
      onClose={handleCloseSuccessDialog}
      open={setupCompleteDialogOpen}
      PaperProps={{ sx: { borderRadius: "12px", overflowX: "hidden" } }}
    >
      <DialogContent sx={{ alignItems: "center", width: "100%", pb: 10 }}>
        {/* Title Section */}
        <Box sx={{ textAlign: "center", mt: 2 }}>
          <Typography sx={{ fontSize: 24, color: "#48768C", fontWeight: 600 }}>
            Setup Complete!
          </Typography>
        </Box>

        {/* Image Section */}
        <Box sx={{ textAlign: "center", mb: -24 }}>
          <CardMedia
            component="img"
            image={checklistDone}
            sx={{
              width: { xs: "60vw", sm: "40vw", md: "30vw", lg: "25vw" },
              height: "auto",
              maxWidth: "485px",
              objectFit: "contain",
            }}
          />
        </Box>

        {/* Message Section */}
        <Stack
          direction="column"
          sx={{ width: "100%", alignItems: "center", mt: 4 }}
        >
          <Typography
            sx={{ fontSize: 22, mb: 1, color: "#8EB5C9", fontWeight: 550 }}
          >
            Awesome!
          </Typography>
        </Stack>
      </DialogContent>

      {/* Button Section */}
      <Box
        sx={{
          width: "100%",
          display: "flex",
          justifyContent: "center",
          alignItems: "center",
          mb: 3,
          flexDirection: "column",
        }}
      >
        <Typography
          sx={{ fontSize: 17, fontWeight: 500, color: "#48768C", mb: 4 }}
        >
          Your account is now set up and ready to use.
        </Typography>
        <Button
          variant="contained"
          onClick={handleButtonClick}
          sx={{
            width: "150px",
            backgroundColor: "transparent",
            border: "1px solid #8EB5C9",
            color: "#647D9E",
          }}
        >
          {isLoading ? "Updating Account" : "Close"}
        </Button>
      </Box>
    </Dialog>
  );
}

export default SetupComplete;
